module.exports = __webpack_public_path__ + "img/zinenzyo_no_mori.8dec66ae.jpg";